export const API_ROUTES = {
  LOGIN: '/login',
  OPEN_AI_CHAT: '/prod/chat'
};
